<template>
    <div class="home-container">
        <app-navigation></app-navigation>
        <main class="home-main">
            <div class="home-hero section-container">
                <footer class="home-intro">
                    <img
                            alt="logo"
                            src="https://presentation-website-assets.teleporthq.io/logos/logo.png"
                            class="home-image"
                    />
                    <h1 class="home-text">
                        {{ intro }}
                    </h1>
                    <div class="home-icon-group">
                        <svg viewBox="0 0 950.8571428571428 1024" class="home-icon">
                            <path
                                    d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"
                            ></path>
                        </svg
                        >
                        <svg viewBox="0 0 877.7142857142857 1024" class="home-icon2">
                            <path
                                    d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                            ></path>
                        </svg
                        >
                        <svg viewBox="0 0 602.2582857142856 1024" class="home-icon4">
                            <path
                                    d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                            ></path>
                        </svg>
                    </div>
                </footer>
                <div class="home-games section-container">
                    <div class="home-max-width max-content-container">
                        <div class="home-heading-container">
                            <h1 class="home-text1 heading2"><span>{{ lineGames }}</span></h1>
                        </div>
                    </div>
                    <div class="home-container1">
                        <app-game></app-game>
                    </div>
                </div>
            </div>
            <div class="home-community section-container">
                <div class="home-container2 max-content-container">
                    <div class="home-heading-container1">
                        <h1 class="home-heading heading2"><span>{{ lineOurCommunity }}</span></h1>
                        <span class="home-text4">{{ lineJoinUsOn }}</span>
                    </div>
                    <div class="home-numbers-container">
                        <social-cards/>
                    </div>
                </div>
            </div>
            <div class="home-partners section-container">
                <div class="home-container3 max-content-container">
                    <span class="home-text5"><span>{{ lineOurPartners }}</span></span>
                    <div class="home-container4">
                        <a v-for="item of partners" :href="item.Link" class="home-partner"
                           v-bind:style="{'max-width': item.MaxWidth ? `${item.MaxWidth}px` : '160px'}">
                            <api-image class="home-image1" :image="item.Logo"/>
                        </a>
                    </div>
                </div>
            </div>
            <div class="home-partners section-container liaa-container">
                <div class="home-container3 liaa-body">
                    <api-image
                            :image="agencyLogo" class="icon-group-icon"/>
                    <p>{{ agencyText }}</p>
                </div>
            </div>
        </main>
        <div class="home-container5">
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import AppNavigation from '../components/navigation'
    import AppGame from '../components/game'
    import SocialCards from '../components/social-cards'
    import AppFooter from '../components/footer'
    import api_fetch from "../api_fetch";

    export default {
        components: {
            AppNavigation,
            AppGame,
            SocialCards,
            AppFooter,
        },
        data() {
            return {
                intro: '',
                partners: [],
                lineGames: null,
                lineOurPartners: null,
                lineOurCommunity: null,
                lineJoinUsOn: null,
                agencyLogo: null,
                agencyText: null
            }
        },
        created() {
            api_fetch('api/App').then((data) => {
                console.log('data', data);
                this.lineGames = data.attributes.LineGames;
                this.lineOurPartners = data.attributes.LineOurPartners;
                this.lineOurCommunity = data.attributes.LineOurCommunity;
                this.lineJoinUsOn = data.attributes.LineJoinUsOn;
                this.agencyLogo = data.attributes.AgencyLogo;
                this.agencyText = data.attributes.AgencyText;
            });

            api_fetch('api/App').then((data) => {
                this.intro = data.attributes.Intro;
            });

            api_fetch('api/Partners').then((data) => {
                data.forEach(item => {
                    this.partners.push(item.attributes);
                });
            })
        }
    }
</script>

<style>
    html {
        scroll-behavior: smooth;
    }

    a, a * {
        transition: 0.3s;
    }

    a:hover, a:hover * {
        color: var(--dl-color-scheme-pink);
    }
</style>

<style scoped>
    .home-container {
        width: 100%;
        display: flex;
        z-index: 100;
        position: relative;
        min-height: 100vh;
        overflow-x: hidden;
        align-items: center;
        flex-direction: column;
        background-color: #020101;
    }

    .home-main {
        flex: 0 0 auto;
        width: 100%;
        display: flex;
        z-index: 100;
        position: relative;
        margin-top: 140px;
        align-items: center;
        border-radius: var(--dl-radius-radius-radius4);
        flex-direction: column;
    }

    .home-hero {
        position: relative;
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .home-intro {
        width: 100%;
        display: flex;
        max-width: var(--dl-size-size-maxwidth);
        margin-top: var(--dl-space-space-fourunits);
        align-items: center;
        padding-top: var(--dl-space-space-threeunits);
        padding-left: var(--dl-space-space-threeunits);
        margin-bottom: var(--dl-space-space-threeunits);
        padding-right: var(--dl-space-space-threeunits);
        padding-bottom: var(--dl-space-space-threeunits);
        justify-content: space-between;
        background-color: var(--dl-color-scheme-background);
        border-left-width: 0px;
        border-right-width: 0px;
        font-size: 10px;
        text-align: center;
        font-weight: normal;

        background-image: linear-gradient(to right, #252525 0 90%, transparent 90% 100%), linear-gradient(to right, #252525 0 90%, transparent 90% 100%);
        background-repeat: repeat no-repeat;
        background-size: 10% 1px;
        background-position: 0 0, 0 calc(100% - 1px);
    }

    .home-image {
        height: 2rem;
        object-fit: cover;
    }

    .home-icon-group {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }

    .home-icon {
        width: var(--dl-size-size-xsmall);
        height: var(--dl-size-size-xsmall);
        margin-right: var(--dl-space-space-twounits);
    }

    .home-icon2 {
        width: var(--dl-size-size-xsmall);
        height: var(--dl-size-size-xsmall);
        margin-right: var(--dl-space-space-twounits);
    }

    .home-icon4 {
        width: var(--dl-size-size-xsmall);
        height: var(--dl-size-size-xsmall);
    }

    .home-games {
        display: flex;
        position: relative;
        padding-top: var(--dl-space-space-fourunits);
        flex-direction: column;
        padding-bottom: var(--dl-space-space-twounits);
        max-width: var(--dl-size-size-maxwidth);
    }

    .home-max-width {
        flex-direction: column;
    }

    .home-heading-container {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        margin-bottom: var(--dl-space-space-fourunits);
        flex-direction: column;
    }

    .home-text1 {
        text-align: center;
    }

    .home-community {
        display: flex;
        margin-top: var(--dl-space-space-fiveunits);
        padding-top: var(--dl-space-space-fiveunits);
        flex-direction: column;
        background-size: cover;
        background-image: url("/playground_assets/os-background.png");
    }

    .home-container2 {
        flex-direction: column;
    }

    .home-heading-container1 {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        margin-bottom: var(--dl-space-space-fourunits);
        flex-direction: column;
    }

    .home-heading {
        color: var(--dl-color-scheme-white);
        text-align: center;
    }

    .home-text4 {
        color: var(--dl-color-scheme-white);
        font-style: normal;
        text-align: center;
        font-weight: 500;
    }

    .home-partners {
        height: 310px;
        display: flex;
        padding-top: var(--dl-space-space-fiveunits);
        border-color: rgba(144, 149, 167, 0.1);
        border-width: 0px;
        flex-direction: column;
        padding-bottom: var(--dl-space-space-sixunits);
        border-bottom-width: 1px;
    }

    .home-container3 {
        flex-direction: column;
    }

    .home-text5 {
        color: var(--dl-color-scheme-darkgray);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        margin-bottom: var(--dl-space-space-twounits);
        letter-spacing: 0.25em;
    }

    .home-container4 {
        flex: 0 0 auto;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        justify-content: center;
    }

    .home-partner {
        height: 80px;
        margin: 0 32px;
    }

    .home-image1 {
        height: 80px;
        width: 100%;
        object-fit: contain;
    }

    .home-image2 {
        height: 80px;
        object-fit: cover;
    }

    .home-image3 {
        height: 80px;
        object-fit: cover;
    }

    .home-image4 {
        height: 80px;
        object-fit: cover;
    }

    .home-image5 {
        height: 80px;
        object-fit: cover;
    }

    .home-image6 {
        height: 80px;
        object-fit: cover;
    }

    .home-container5 {
        display: flex;
        align-self: stretch;
        margin-top: var(--dl-space-space-threeunits);
        align-items: stretch;
        flex-direction: column;
    }

    @media (max-width: 991px) {
        .home-numbers-container {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    @media (max-width: 767px) {
        .home-intro {
            padding-left: var(--dl-space-space-twounits);
            padding-right: var(--dl-space-space-twounits);
        }

        .home-text {
            text-align: center;
            margin-left: var(--dl-space-space-unit);
            margin-right: var(--dl-space-space-unit);
        }

        .home-games {
            padding-bottom: 0;
        }

        .home-numbers-container {
            grid-template-columns: 1fr 1fr;
        }
    }

    @media (max-width: 479px) {
        .home-intro {
            padding: var(--dl-space-space-unit);
            flex-direction: column;
        }

        .home-image {
            margin-bottom: var(--dl-space-space-unit);
        }

        .home-text {
            margin-left: 0px;
            margin-right: 0px;
            margin-bottom: var(--dl-space-space-unit);
        }

        .home-container4 {
            justify-content: center;
        }
    }

    .liaa-container {
        margin-top: 0;
        padding-top: 50px;
    }

    .liaa-body {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .liaa-container p {
        margin-top: 14px;
        width: 400px;
        text-align: center;
        font-size: 80%;
    }
</style>
